export { default } from "./useLazyContentPromotionFormResponsesGet";
